export const apiUrlSoCouponSurveySelectedQuestion = 'socoupon/survey-selected-question/';
export const apiUrlSoCouponSurveyAnswer = 'socoupon/survey-answer/';
